import { EMAIL_REGEX } from '@/constants/static';
import { StepForms } from '@/stores/slices/setup-fund-slice';

export const validateShareClasses = (
  shareClasses: StepForms['numberUnits']['shareClasses'],
): boolean =>
  (shareClasses?.length ?? 0) > 0 &&
  shareClasses.every((line) =>
    Boolean(
      line.className?.trim() &&
        line.shares !== null &&
        line.shares > 0 &&
        line.shareholders.every((sh) =>
          Boolean(
            sh.fullName?.trim() &&
              sh.email?.trim() &&
              EMAIL_REGEX.test(sh.email.trim()) &&
              sh.numberOfShares !== null &&
              sh.numberOfShares > 0 &&
              sh.type?.trim(),
          ),
        ) &&
        Boolean(
          line.shares >=
            line.shareholders.reduce(
              (acc, shareholder) => acc + (shareholder.numberOfShares ?? 0),
              0,
            ),
        ),
    ),
  );

export const validateSubscriptionOpts = (opts: StepForms['subscriptionOptions']): boolean => {
  if (opts.subscriptionMethod === null) return false;
  if (opts.subscriptionMethod === 'Crypto') return true;
  const bank = opts.wireInformation?.bankDetails;
  const bene = opts.wireInformation?.beneficiaryDetails;
  if (!bank || !bene) return false;
  return Boolean(
    bank.name?.trim() &&
      bank.address?.trim() &&
      bank.city?.trim() &&
      bank.country?.trim() &&
      (bank.country?.trim() === 'US' ? bank.state?.trim() && bank.zipCode?.trim() : true) &&
      bene.name?.trim() &&
      bene.address?.trim() &&
      bene.accountNumber?.trim() &&
      bene.bankIdentifierCode?.trim() &&
      bene.city?.trim() &&
      bene.country?.trim() &&
      (bene.country?.trim() === 'US'
        ? bene.state?.trim() && bene.zipCode?.trim() && bene.ABARouting?.trim()
        : true),
  );
};
